import { IOperator, expandOperatorIds } from '@entities/operator';

export interface IFilterOperatorState {
    operatorsFilter: IOperator['id'][];
}

export interface IFilterOperatorMutations {
    setOperatorFilter: (state: IFilterOperatorState, value: number[]) => void;
}

const DefaultState = (): IFilterOperatorState => ({
    operatorsFilter: [],
});

export default {
    namespaced: true,
    state: DefaultState(),
    mutations: {
        setOperatorFilter(state: IFilterOperatorState, value: IOperator['id'][]) {
            // Выбор группы ТО хранится развёрнутым: и из UI, и из URL/Backbone сюда может
            // прийти только 226, а офферы отеля приходят от 299. Разворачиваем на входе,
            // чтобы предикаты фильтрации сравнивали id напрямую и ничего не знали о группе.
            state.operatorsFilter = expandOperatorIds(value);
        },
    },
};

export const NAMESPACE = 'operatorFilterModelName';
